export default {
  property_accessor: (hash: object, key: string) => {
    return hash[key]
  }
}
